import { render } from "./SearchResultPage.vue?vue&type=template&id=1d9749aa&ts=true"
import script from "./SearchResultPage.vue?vue&type=script&lang=ts"
export * from "./SearchResultPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__